<button
  (click)="handleLike()"
  [ngClass]="{
    btn: true,
    'btn-sm': true,
    'btn-primary': isFavorited,
    'btn-outline-primary': !isFavorited
  }"
>
  <i class="ion-heart"></i>
  <span>&nbsp; {{ favoritesCount }}</span>
</button>
